import React, { Component } from 'react'

export default class PauseDropdown extends Component {
  constructor(props) {
    super(props)

    this.insertPause = this.insertPause.bind(this);

    this.state = {
      isOpen: false
    }
  }



  toggle = (e) => {
    e.preventDefault();
    this.setState({
      isOpen: !this.state.isOpen
    });
  };

  insertPause(e, duration) {
    e.preventDefault();

    var pauseDuration = '1s';

    if (duration < 1)
      pauseDuration = duration * 1000 + 'ms';
    else
      pauseDuration = duration + 's';

    var textArea = document.getElementById('inputText');

    //IE support
    if (document.selection) {
      textArea.focus();
      var sel = document.selection.createRange();
      sel.text = '<break time=\'' + pauseDuration + '\'/>';
    }
    //MOZILLA and others
    else if (textArea.selectionStart || textArea.selectionStart === '0') {
      var startPos = textArea.selectionStart;
      var endPos = textArea.selectionEnd;
      textArea.value = textArea.value.substring(0, startPos)
        + '<break time=\'' + pauseDuration + '\'/>'
        + textArea.value.substring(endPos, textArea.value.length);
    } else {
      textArea.value += '<break time=\'' + pauseDuration + '\'/>';
    }
    if (this.state.isOpen) {
      this.setState({
        isOpen: false
      });
    }
    this.props.onChange(textArea.value);
  }

  render() {
    var isOpen = this.state.isOpen;
    return (
      <div>
        <button tabIndex="-1" onClick={this.toggle} className="relative z-10 block bg-blue-700 hover:bg-blue-800 text-white font-bold py-1 px-4 mr-2 border border-teal-800 rounded">Add Pause:</button>
        {isOpen &&
          <div>

            <button onClick={this.toggle} tabIndex="-1" className="fixed inset-0 w-full h-full bg-black opacity-25 cursor-default"></button>

            <div className="absolute mt-2 py-2 w-20 bg-white rounded-lg border border-gray-500 shadow-xl">
              <button onClick={(e) => this.insertPause(e, 0.5)} className="block w-full text-left px-4 py-2 text-gray-800 hover:bg-blue-500 hover:text-white">0.5s</button>
              <button onClick={(e) => this.insertPause(e, 1)} className="block w-full text-left px-4 py-2 text-gray-800 hover:bg-blue-500 hover:text-white">1s</button>
              <button onClick={(e) => this.insertPause(e, 2)} className="block w-full text-left px-4 py-2 text-gray-800 hover:bg-blue-500 hover:text-white">2s</button>
              <button onClick={(e) => this.insertPause(e, 3)} className="block w-full text-left px-4 py-2 text-gray-800 hover:bg-blue-500 hover:text-white">3s</button>
              <button onClick={(e) => this.insertPause(e, 4)} className="block w-full text-left px-4 py-2 text-gray-800 hover:bg-blue-500 hover:text-white">4s</button>
            </div>

          </div>
        }
      </div>
    )
  }
}
